import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, ViewChild } from "@angular/core";
import { AlertMessageService, LoadingService } from "@serpro/ngx-suite-rfb";
import { AmbienteService } from "src/app/shared/services/ambiente.service";
import { LudService } from "src/app/shared/services/lud.service";
import { Ambiente } from "src/app/shared/model/ambiente.model";
import { Lud, TipoLud } from "src/app/shared/model/lud.model";
import { LudEncontrado } from "src/app/shared/model/lud-encontrado.model";
import { BancoRecursos } from "src/app/shared/util/banco-recursos.util";
import { SegmentoTela } from "src/app/shared/model/segmento.model";
import { MapaLuds } from "src/app/shared/util/mapa-luds.util";
import { MapaTextoAto } from "src/app/shared/util/mapa-texto-ato.util";
import { QuillHtmlUtil } from "src/app/shared/util/quill-html.util";
import { FakeQuill } from "src/app/atos/components/editar-conteudo-ato/editar-conteudo-ato.component";
import { fromEvent, throttleTime } from "rxjs";
import Quill from "quill";

@Component({
    selector: 'app-confeccionar-luds',
    templateUrl: './confeccionar-luds.component.html',
    styleUrls: ['./confeccionar-luds.component.css', '../../../../../src/app/shared/css/contraste.css']
})
export class ConfeccionarLUDsComponent implements OnInit {

    @Input() segmentos: SegmentoTela[] = [];
    @Output() fechar: EventEmitter<SegmentoTela[] | null> = new EventEmitter();
    @ViewChild('conteudoAto') conteudoAto: ElementRef;


    // Define o texto selecionado no conteúdo do ato. Localizado em um único segmento. Realçado forçadamente em azul.
    selecaoAtual: Lud | null = null;

    // Mapeia todos os LUDs e palavras-chave do conteúdo do ato.
    mapaLuds: MapaLuds = new MapaLuds();

    // Define o LUD selecionado no conteúdo e informa o Painel para que este localize o recurso associado ao LUD.
    ludSelecionado: Lud | null = null;

    // Define o banco de recursos em memória para evitar muitas idas ao backend.
    bancoRecursos: BancoRecursos;

    // Define a quantidade de segmentos carregados no Quill.
    segmentosCarregados = 0;
    // Define se ainda está carregando segmentos.
    carregandoSegmentos = true;

    constructor(
        private readonly loadingService: LoadingService,
        private readonly ambienteService: AmbienteService,
        private readonly ludService: LudService,
        private readonly alertMessageService: AlertMessageService,
        private readonly ngZone: NgZone
    ) {}

    ngOnInit(): void {
        this.loadingService.show();
        this.ambienteService.getAmbiente().subscribe({
            next: (ambiente: Ambiente) => {
                this.bancoRecursos = new BancoRecursos(ambiente);
                this.loadingService.hide();
            },
            error: () => {
                this.loadingService.hide();
            }
        });

        this.carregarSegmentosQuill();
        setTimeout(() => {
            this.prepareDebouncingScrollConteudoAto();
            this.ajustarSegmentosVisiveisNoContainer();
        }, 1000);
    }

    removerClassQuillContainer(editor: Quill) {
        const editorElement = editor.root;
        const contunerElement = editorElement.parentElement;
        if(contunerElement) {            
            contunerElement.classList.remove('ql-container');
        }
    }

    public quillOnEditorCreated(editor: Quill, idx: number) {
        this.removerClassQuillContainer(editor);
        const segmento = this.segmentos[idx];
        if (segmento.idTipoSegmento != 16) {
            segmento.editor = editor;
        }
        const ludsOriginais =  QuillHtmlUtil.localizarLinksOriginais(idx, editor);
        for (const l of ludsOriginais) {
            this.mapaLuds.incluirLud(l);
            QuillHtmlUtil.transformarDeAncoraParaCode(l);
            QuillHtmlUtil.colorirLud(l);
        }
        setTimeout(() => {
            for (const l of this.mapaLuds.buscarLudsNoSegmento(idx)) {
                l.quill = editor;
                QuillHtmlUtil.colorirLud(l);
            }
        }, 100);
        
    }
    
    public quillOnMouseDown() {
        this.removerSelecao();
    }
    
    public quillOnMouseUp(idx: number) {
        this.quillOnSelectionChange(idx);
    }

    private quillOnSelectionChange(idx: number) {
        const segmento = this.segmentos[idx];

        // não permite a seleção em ementas ou anexos.
        if (!segmento.editor || segmento.idTipoSegmento == 1 || segmento.idTipoSegmento == 16) {
            return;
        }

        const selecao = QuillHtmlUtil.obterSelecaoTexto(idx, segmento);
        if (selecao) {

            if (selecao.fim > selecao.inicio) {
                this.ludSelecionado = null;
            }

            const ludsNoIntervalo = this.mapaLuds.buscarLudsNoIntervalo(selecao.idx, selecao.inicio, selecao.fim);
            const luds = ludsNoIntervalo.filter(l => l.tipo != TipoLud.LUD_PALAVRA_CHAVE);

            if (luds.length == 1) {
                // se houver apenas um LUD ou parte dele na seleção ou na posição do click, seleciona o LUD para o Painel.
                this.ludSelecionado = Lud.criarLudDoUrlEFragmento(luds[0].url, luds[0].fragmento);
            }

            if (luds.length == 1 && selecao.fim == selecao.inicio) {
                // se foi um click em um LUD, destaca a seleção para todo o LUD
                selecao.inicio = luds[0].inicio;
                selecao.fim = luds[0].fim;
                this.selecaoAtual = selecao;
                QuillHtmlUtil.destacarSelecao(selecao);

            } else if (ludsNoIntervalo.length == 1 && luds.length == 0) {
                // há um único LUD e é uma palavra-chave.
                if (selecao.fim == selecao.inicio) {
                    selecao.inicio = ludsNoIntervalo[0].inicio;
                    selecao.fim = ludsNoIntervalo[0].fim;
                }
                QuillHtmlUtil.destacarSelecao(selecao);
                this.selecaoAtual = selecao;
                this.ludSelecionado = new Lud();
            } else if (selecao.fim > selecao.inicio) {
                // se não foi um click, destaca a seleção realizada.
                this.selecaoAtual = selecao;
                QuillHtmlUtil.destacarSelecao(selecao);
            }
        }
    }

    /**
     * Remove o destaque azul da seleção e realça os LUDs nas cores correspondentes.
     */
    private removerSelecao() {
        const s = this.selecaoAtual;
        if (s) {
            QuillHtmlUtil.tirarRealceSelecao(s);
            const ludsAfetados = this.mapaLuds.buscarLudsNoIntervalo(s.idx, s.inicio, s.fim);
            for (const lud of ludsAfetados) {
                QuillHtmlUtil.colorirLud(lud);
            }
            this.selecaoAtual = null;        
        }
    }

    /**
     * Método da localização e confecção automática de LUDs.
     */
    public localizarEConfeccionarLuds() {
        this.loadingService.show();

        // Remove os destaques antigos, exclui as palavras-chave.
        this.removerRealcesNoTextoAto();

        // Constrói o mapa do conteúdo do ato.
        const mapaTextoAto = new MapaTextoAto(this.segmentos);

        // Solicita ao backend a localização de LUDs e palavras-chave.
        this.ludService.localizar(mapaTextoAto.textoAto).subscribe({
            next: (luds: LudEncontrado[]) => {

                // Confecciona os LUDs localizados e os realça com cores.
                this.confeccionarEcolorirLudsLocalizados(luds, mapaTextoAto);
                this.loadingService.hide();
            },
            error: () => {
                this.loadingService.hide();
            }
        });
    }

    /**
     * Confecciona os LUDs localizados e os realça com cores.
     */
    private confeccionarEcolorirLudsLocalizados(ludsLocalizados: LudEncontrado[], mapaTextoAto: MapaTextoAto) {
        const listaLuds: Lud[] = [];
        for (const l of ludsLocalizados) {

            // Inclui recurso encontrado no banco de recursos.
            if (l.recursoNormas) {
                this.bancoRecursos.incluirAtoRecursoNormas(l.recursoNormas);
            } else if (l.recursoInternet) {
                this.bancoRecursos.incluirRecursoInternet(l.recursoInternet);
            }

            // cria o LUD e inclui no mapa de LUDs.
            const lud = mapaTextoAto.obterLudComPosicaoAjustada(l.inicio, l.fim);
            if (l.palavraChave) {
                lud.tipo = TipoLud.LUD_PALAVRA_CHAVE;
                lud.url = '';
            } else if (l.recursoNormas) {
                lud.tipo = TipoLud.LUD_NORMAS;
                lud.url = this.bancoRecursos.obterUrlNormasExterno(l.recursoNormas.idAto);
            } else if (l.recursoInternet) {
                lud.tipo = TipoLud.LUD_INTERNET;
                lud.url = l.recursoInternet.url;
            } else if (l.url) {
                lud.tipo = TipoLud.LUD_URL;
                lud.url = lud.texto;
            }
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            lud.quill = this.segmentos[lud.idx].editor!;
            listaLuds.push(lud)
        }
        // Ordena de modo a tratar na sequência LUDs do Normas, LUDs de internet, URLs localizados e palavras-chave.
        listaLuds.sort((a, b) => a.tipo.valueOf() - b.tipo.valueOf());
        for (const lud of listaLuds) {
            if (this.mapaLuds.existeIntervaloParaNovoLud(lud.idx, lud.inicio, lud.fim)) {

                // Somente cria o LUD se houver espaço (não entra em conflito com LUDs anteriores ou em conflito no texto).
                if (lud.tipo != TipoLud.LUD_PALAVRA_CHAVE) {
                    // cria a aparência de link (sublinhado) somente se não for palavra-chave.
                    lud.quill.formatText(lud.inicio, lud.fim - lud.inicio, 'code', true);
                }

                // Inclui LUD no mapa de LUDs (que mapeia os LUDs na tela) e destaca na cor referente ao tipo.
                this.mapaLuds.incluirLud(lud);
                QuillHtmlUtil.colorirLud(lud);
            }
        }
    }

    /**
     * Remove as cores no conteúdo do texto. Exclui as palavras-chave mas mantém os demais LUDs. 
     */
    private removerRealcesNoTextoAto() {
        if (this.selecaoAtual) {
            this.removerSelecao();
        }
        for (const l of this.mapaLuds.obterListaLuds()) {
            QuillHtmlUtil.colorirLud(l);
            if (l.tipo == TipoLud.LUD_PALAVRA_CHAVE) {
                this.mapaLuds.excluirLud(l);
            }
        }
    }
    
    /**
     * Confecciona um LUD confirmado no Painel (ao selecionar um dispositivo ou pelo botão Confirmar).
     */
    public confeccionarLudDoPainel(lud: Lud | null) {
        if (lud == null) {
            // Ao receber um null, a instrução é para descartar o LUD na seleção atual.
            this.descartarLud();
            return;
        }

        if (this.selecaoAtual) {
            const s = this.selecaoAtual;
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const quill = s.quill!;
            const ludsNoIntervalo = this.mapaLuds.buscarLudsNoIntervalo(s.idx, s.inicio, s.fim);
            const qtdLuds = ludsNoIntervalo.filter(l => l.tipo != TipoLud.LUD_PALAVRA_CHAVE).length;

            // É necessário que haja no máximo um LUD confeccionado (ignorar palavras-chave)
            if (qtdLuds <= 1) {

                // Exclui as palavras-chave e (talvez) o LUD dentro da seleção.
                for (const ludAExcluir of ludsNoIntervalo) {
                    QuillHtmlUtil.tirarRealceSelecao(ludAExcluir);
                    this.mapaLuds.excluirLud(ludAExcluir);
                    quill.formatText(ludAExcluir.inicio, ludAExcluir.fim - ludAExcluir.inicio, 'code', false);
                }
                QuillHtmlUtil.destacarSelecao(this.selecaoAtual);

                const l = new Lud();
                l.quill = quill;
                l.tipo = Lud.obterTipoLud(lud.url);
                l.idx = s.idx;
                l.inicio = s.inicio;
                l.fim = s.fim;
                l.url = lud.url;
                l.fragmento = lud.fragmento;
                if (lud.fragmento) {
                    l.url += '#' + lud.fragmento;
                }
                this.mapaLuds.incluirLud(l);
                quill.formatText(l.inicio, l.fim - l.inicio, 'code', true);
            }
        }
    }

    /**
     * Descarta o LUD (ignorando palavras-chave) dentro da seleção atual.
     */
    private descartarLud() {
        if (this.selecaoAtual) {
            const s = this.selecaoAtual;
            const ludsNoIntervalo = this.mapaLuds.buscarLudsNoIntervalo(s.idx, s.inicio, s.fim);
            const ludsReais = ludsNoIntervalo.filter(l => l.tipo != TipoLud.LUD_PALAVRA_CHAVE);

            // É necessário que haja somente um LUD confeccionado (ignorar palavras-chave)
            if (ludsReais.length == 1) {
                const lud = ludsReais[0];
                QuillHtmlUtil.tirarRealceSelecao(lud);
                this.mapaLuds.excluirLud(lud);
                const quill = this.selecaoAtual.quill;
                quill.formatText(lud.inicio, lud.fim - lud.inicio, 'code', false);
                const selecao = this.selecaoAtual;
                this.removerSelecao();
                selecao.inicio = lud.fim;
                selecao.fim = lud.fim;
                this.selecaoAtual = selecao;
                QuillHtmlUtil.destacarSelecao(this.selecaoAtual);
                quill.setSelection(lud.fim, 0);
            }
        }
    }

    /**
     * Fecha a tela de confeccção de LUDs sem alterar o conteúdo original do ato.
     */
    public cancelarEdicoes() {
        this.fechar.emit(null);
        this.alertMessageService.dismissAll();
    }

    /**
     * Realiza a confecção de LUDs no conteúdo do ato.
     */
    public confirmarEdicoes() {
        // Remove o realce da seleção atual.
        this.removerSelecao();
        this.alertMessageService.dismissAll();

        // Remove o realce de todos os LUDs e transforma os LUDs (tag <code>) em links (tag <a>)
        const luds = this.mapaLuds.obterListaLuds();
        QuillHtmlUtil.ajustarLinksParaSalvar(luds);

        // Obtém o textoIntegra com os LUDs confeccionados.
        for (const segmento of this.segmentos) {
            if (segmento.editor) {
                segmento.textoIntegra = segmento.editor.root.innerHTML
            }
        }
        this.fechar.emit(this.segmentos);
    }

    /**
     * Navega entre os LUDs da tela (inclusive palavras-chave).
     */
    public navegarProximoLud() {
        let lud: Lud | null = null;
        if (this.selecaoAtual) {    
            // Busca a partir da seleção atual.
            const s = this.selecaoAtual;
            lud = this.mapaLuds.buscarProximoLudGlobal(s.idx, s.inicio, s.fim);

            this.removerSelecao();
        } else {
            // Busca do começo.
            lud = this.mapaLuds.buscarProximoLudGlobal(0, 0, 0);
        }
        if (lud) {

            lud.quill.setSelection(lud.inicio, lud.fim - lud.inicio);
            this.quillOnSelectionChange(lud.idx);

            // Ajusta o scroll para exibir o segmento todo na parte inferior da área do conteúdo do ato.
            const offsetTop = (lud.quill as unknown as FakeQuill).container.offsetTop - 30;
            const offsetHeight = (lud.quill as unknown as FakeQuill).container.offsetHeight;
            const conteudoAto = document.getElementsByName('conteudo-ato')[0];
            const height = conteudoAto.clientHeight;
            if (conteudoAto.scrollTop < offsetTop + offsetHeight - height) {
                conteudoAto.scrollTop = offsetTop + offsetHeight - height;
            }
            if (conteudoAto.scrollTop > offsetTop) {
                conteudoAto.scrollTop = offsetTop;
            }
        }
    }

    /**
     * Quando se faz scroll no conteúdo do ato, ajusta os componentes Quill que devem ser instanciados ou removidos.
     */
    public scrollConteudoAto() {
        setTimeout(() => {
            this.ajustarSegmentosVisiveisNoContainer();
        }, 300);
    }

    /**
     * A aplicação necessita reduzir o número de componentes Quill ativos para melhorar a performance.
     * Esta função verifica se o segmento está visível no container. Se não estiver, remove (ou não instancia) o editor.
     */    
    private ajustarSegmentosVisiveisNoContainer() {
        const container = document.getElementById('conteudoAto') as HTMLDivElement;
        this.segmentos.forEach((s, idx) => {
            s.visivel = this.segmentoEstaVisivel(document.getElementById('segmentoLud' + idx) as HTMLDivElement, container, 50);
            if (s.visivel) {
                s.fresh = false;  
                s.editor?.root.parentElement?.classList.add('ql-container');
            } else {
                s.editor?.root.parentElement?.classList.remove('ql-container'); 
            }
        });
    }

    /**
     * Esta função verifica se o segmento está visível no container.
     * @param divSegmento
     * @param divContainer 
     * @param folga pixels de folga para considerar o segmento visível
     * @returns boolean
     */
    private segmentoEstaVisivel(divSegmento: HTMLDivElement, divContainer: HTMLDivElement, folga: number): boolean {
        const segmentoRect = divSegmento.getBoundingClientRect();
        const containerRect = divContainer.getBoundingClientRect();
        return (
            segmentoRect.top < containerRect.bottom + folga &&
            segmentoRect.bottom > containerRect.top - folga
        );
    }
    /**
     * Prepara o evento de Scroll do conteudoAto2 para que se evitem muitos eventos por segundo (debouncing).
     * Sem isso, a performance do navegador pode ser prejudicada.
     */
    private prepareDebouncingScrollConteudoAto() {
        this.ngZone.runOutsideAngular(() => {
            fromEvent(this.conteudoAto.nativeElement, 'scroll')
                .pipe(throttleTime(200)) // Throttle de 200ms
                .subscribe(() => {
                    this.ngZone.run(() => {
                        this.scrollConteudoAto();
                    });
                });
        });
    }
    
    /**
     * Carrega os segmentos do Quill de forma assíncrona. Uma Promise que é resolvida quando todos os segmentos são carregados.
     * Os segmentos são carregados em lotes de 10 e atualiza a variável segmentosCarregados.
     */
    private async carregarSegmentosQuill() {
        const tamanhoBatch = 10;
        const totalDeSegmentos = this.segmentos.length;
        let batchAtual = 0;

        while (batchAtual < totalDeSegmentos) {
            const batchFinal = Math.min(batchAtual + tamanhoBatch, totalDeSegmentos);
            await Promise.all(this.segmentos.slice(batchAtual, batchFinal).map(s => {
                if (s.fresh) {
                    s.fresh = false;
                }
            }));

            batchAtual += tamanhoBatch;

            this.segmentosCarregados = batchFinal;
            this.carregandoSegmentos = batchFinal < totalDeSegmentos;
            
            await new Promise(resolve => setTimeout(resolve, 0));
        }
    }
}
